"use strict";

require("core-js/modules/es6.promise");

require("core-js/modules/es6.object.to-string");

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var tslib_1 = require("tslib");

var classes_1 = require("./classes");

var relations_1 = require("./relations");

var attributes_1 = require("./attributes");

var theme_1 = require("./theme");

var hbs_helpers_1 = require("./hbs_helpers");

var helpers_1 = require("./helpers");

var N3 = require('n3');

exports.transformGUFO2HTML = function (gufoStringFile, options) {
  return tslib_1.__awaiter(void 0, void 0, void 0, function () {
    var _a, baseIRI, format, documentationProps, _b, _c, title, _d, description, _e, customTheme, parser_1, _f, quads, _g, prefixes, model, theme, classes, relations, attributes, prefixList, styles, namespace, template, html, error_1;

    return tslib_1.__generator(this, function (_h) {
      switch (_h.label) {
        case 0:
          _a = options || {}, baseIRI = _a.baseIRI, format = _a.format, documentationProps = _a.documentationProps;
          _b = documentationProps || {}, _c = _b.title, title = _c === void 0 ? 'Ontology' : _c, _d = _b.description, description = _d === void 0 ? '' : _d, _e = _b.theme, customTheme = _e === void 0 ? {} : _e;
          _h.label = 1;

        case 1:
          _h.trys.push([1, 5,, 6]);

          parser_1 = new N3.Parser({
            baseIRI: baseIRI,
            format: format
          });
          return [4, new Promise(function (resolve, reject) {
            var quads = [];
            parser_1.parse(gufoStringFile, function (error, quad, prefix) {
              return tslib_1.__awaiter(void 0, void 0, void 0, function () {
                var prefixes_1;
                return tslib_1.__generator(this, function (_a) {
                  if (error) {
                    reject(error);
                  } else if (quad) {
                    quads.push(quad);
                  } else if (prefix) {
                    prefixes_1 = JSON.parse(JSON.stringify(prefix));
                    resolve({
                      quads: quads,
                      prefixes: prefixes_1
                    });
                  }

                  return [2];
                });
              });
            });
          })];

        case 2:
          _f = _h.sent(), quads = _f.quads, _g = _f.prefixes, prefixes = _g === void 0 ? {} : _g;
          return [4, new N3.Store(quads)];

        case 3:
          model = _h.sent();
          theme = tslib_1.__assign(tslib_1.__assign({}, theme_1["default"]), customTheme);
          classes = classes_1.getClasses(model, prefixes);
          relations = relations_1.getRelations(model, prefixes);
          attributes = attributes_1.getAttributes(model, prefixes);
          prefixList = helpers_1.getPrefixList(prefixes);
          styles = theme_1.generateOverrideStyles(theme.overrides);
          namespace = baseIRI;
          template = hbs_helpers_1.getHBSTemplate(options);
          return [4, template({
            title: title,
            description: description,
            namespace: namespace,
            prefixList: prefixList,
            classes: classes,
            relations: relations,
            attributes: attributes,
            styles: styles,
            theme: theme
          })];

        case 4:
          html = _h.sent();
          return [2, {
            html: html,
            prefixes: prefixes
          }];

        case 5:
          error_1 = _h.sent();
          return [2, {
            html: null,
            prefixes: null,
            error: error_1
          }];

        case 6:
          return [2];
      }
    });
  });
};